'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = ['M16 256l.2 6.1c2.1 30 19.8 55.7 45.1 69.1l5.8 3.1-1.9 6.3c-9 29.2-1.9 62.2 21.1 85.2 23 23 56 30 85.2 21.1l6.3-1.9 3.1 5.8c14.3 27 42.6 45.3 75.2 45.3s60.8-18.4 75.1-45.3l3.1-5.8 6.3 1.9c29.2 9 62.2 2 85.2-21.1s30-56 21.1-85.2l-1.9-6.3 5.8-3.1c27-14.3 45.3-42.6 45.3-75.1s-18.4-60.9-45.3-75.2l-5.8-3.1 1.9-6.3c9-29.2 2-62.1-21.1-85.2-23-23-56-30.1-85.2-21.1l-6.3 1.9-3.1-5.8C316.8 34.3 288.6 16 256 16s-60.9 18.3-75.2 45.3l-3.1 5.8-6.3-1.9c-29.1-9-62.1-1.9-85.2 21.1s-30 56-21.1 85.2l1.9 6.3-5.8 3.1C34.3 195.1 16 223.4 16 256zm140.8 4.1l11.5-11.1 5.6 5.8 55.7 57.6 108.1-148.7 4.7-6.5 12.9 9.4-4.7 6.5-113.7 156.4-5.6 7.7-6.6-6.8-62.3-64.5-5.6-5.8z', 'M256 0c36.4 0 68.3 19.3 86 48.2 33-7.9 69.2 1 95 26.8 25.8 25.8 34.6 61.9 26.7 94.9 28.9 17.7 48.2 49.7 48.2 86.1 0 36.4-19.4 68.3-48.2 86 7.9 33-.9 69.2-26.7 95s-62 34.6-95 26.7c-17.7 28.9-49.6 48.2-86 48.2-36.5 0-68.4-19.3-86.1-48.2-33 7.9-69.1-1-94.9-26.7-25.8-25.8-34.7-62-26.8-95-27-16.6-45.6-45.4-47.9-78.8L0 256c0-36.4 19.3-68.3 48.2-86.1-7.9-33 1-69.2 26.8-94.9s62-34.6 94.9-26.8C187.7 19.3 219.6 0 256 0zm0 16c-32.6 0-60.9 18.3-75.2 45.3l-3.1 5.8-6.3-1.9c-29.1-9-62.1-1.9-85.2 21.1s-30 56-21.1 85.2l1.9 6.3-5.8 3.1C34.3 195.1 16 223.4 16 256l.2 6.1c2.1 30 19.8 55.7 45.1 69.1l5.8 3.1-1.9 6.3c-9 29.2-1.9 62.2 21.1 85.2 23 23 56 30 85.2 21.1l6.3-1.9 3.1 5.8c14.3 27 42.6 45.3 75.2 45.3s60.8-18.4 75.1-45.3l3.1-5.8 6.3 1.9c29.2 9 62.2 2 85.2-21.1s30-56 21.1-85.2l-1.9-6.3 5.8-3.1c27-14.3 45.3-42.6 45.3-75.1s-18.4-60.9-45.3-75.2l-5.8-3.1 1.9-6.3c9-29.2 2-62.1-21.1-85.2-23-23-56-30.1-85.2-21.1l-6.3 1.9-3.1-5.8C316.8 34.3 288.6 16 256 16zm99.3 150.7l-4.7 6.5-113.7 156.4-5.6 7.7-6.6-6.8-62.3-64.5-5.6-5.8 11.5-11.1 5.6 5.8 55.7 57.6 108.1-148.7 4.7-6.5 12.9 9.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;